import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "og-select-result d-flex align-items-center" };
import { computed } from 'vue';
import TagLabel from '@/pages/partials/tag/tag-label.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'field-select',
    props: {
        modelValue: {},
        items: {},
        defaults: { default: () => [] },
        keyField: { default: 'id' },
        textField: { default: 'title' },
        placeholder: { default: undefined },
        searchable: { type: Boolean, default: false }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const allSelected = computed(() => props.items.length > 0 && props.modelValue.length === props.items.length);
        const someSelected = computed(() => props.modelValue.length > 0);
        const showResetTag = computed(() => {
            if (!props.defaults.length || !props.modelValue.length) {
                return false;
            }
            return props.modelValue.length !== props.defaults.length
                || !props.modelValue.every(id => props.defaults.includes(id));
        });
        function toggleAll(event) {
            // The header sits inside the dropdown, which would otherwise close on click.
            event.stopPropagation();
            emit('update:modelValue', allSelected.value ? [] : props.items.map(item => item[props.keyField]));
        }
        function resetToDefaults() {
            emit('update:modelValue', [...props.defaults]);
        }
        return (_ctx, _cache) => {
            const _component_s_checkbox = _resolveComponent("s-checkbox");
            const _component_s_select = _resolveComponent("s-select");
            return (_openBlock(), _createBlock(_component_s_select, {
                "key-field": __props.keyField,
                "text-field": __props.textField,
                items: __props.items,
                "model-value": __props.modelValue,
                placeholder: __props.placeholder,
                searchable: __props.searchable,
                multiple: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:modelValue', $event)))
            }, _createSlots({
                header: _withCtx(() => [
                    _createElementVNode("div", {
                        class: "pt-tiny px-tiny",
                        onClick: toggleAll
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_s_checkbox, {
                                class: "mr-2",
                                "model-value": allSelected.value,
                                "minus-checker": someSelected.value && !allSelected.value
                            }, null, 8, ["model-value", "minus-checker"]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('actions.select_all')), 1)
                        ])
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "my-1" }, null, -1))
                ]),
                _: 2
            }, [
                (showResetTag.value)
                    ? {
                        name: "tags-end",
                        fn: _withCtx(() => [
                            _createVNode(TagLabel, {
                                theme: "success",
                                uppercase: false,
                                "triangle-border": false,
                                clickable: "",
                                onClick: resetToDefaults
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('actions.reset_to_default')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032, ["key-field", "text-field", "items", "model-value", "placeholder", "searchable"]));
        };
    }
});
